import { PREMIUM_FEATURES } from '../data/mock';
import { Sparkles } from 'lucide-react';

export default function PremiumFeatures() {
  return (
    <section className="section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="chip mb-4">Premium Features</p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900">
            Advanced capabilities for growing teams
          </h2>
          <p className="mt-4 text-slate-600">
            Unlock enterprise-grade features to supercharge your WhatsApp marketing with powerful tools built for scale.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PREMIUM_FEATURES.map((f) => (
            <div key={f.title} className="relative bg-white border border-slate-200 rounded-2xl p-6 card-lift">
              {f.popular && (
                <span className="absolute top-4 right-4 text-[10px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full uppercase tracking-wider">
                  Popular
                </span>
              )}
              <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 grid place-items-center">
                <Sparkles size={18} />
              </div>
              <h3 className="mt-4 font-bold text-slate-900">{f.title}</h3>
              <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {[
            { v: '99.9%', l: 'Message Delivery Rate' },
            { v: '10K+', l: 'Messages Per Minute' },
            { v: '35+', l: 'App Integrations' },
            { v: '24/7', l: 'API Availability' },
          ].map((s) => (
            <div key={s.l} className="text-center">
              <p className="text-2xl md:text-3xl font-extrabold text-emerald-600">{s.v}</p>
              <p className="mt-1 text-xs md:text-sm text-slate-500">{s.l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
